import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import MainHead from "./components/MainHead";
import DashboardHead from "./components/DashboardHead";
import MainScripts from "./components/MainScripts";
import MainStyles from "./components/MainStyles";

import "./App.css";
import Home from "./pages/home";
import About from "./pages/about";
import Contact from "./pages/contact";
import Home2 from "./pages/home2";
import Home3 from "./pages/home3";
import Home4 from "./pages/home4";
import Home5 from "./pages/home5";
import NewBooking from "./pages/new_booking";
import BookingConfirmation from "./pages/booking_confirmation";
import ForgotPassword from "./pages/forgotPassword";
import ResetPassword from "./pages/resetPassword";
import Dashboard from "./pages/dashboard/dashboard";
import Profile from "./pages/dashboard/profile";
import Bookings from "./pages/dashboard/bookings";
import BookingDetails from "./pages/dashboard/bookingDetails";
import SeoPage from "./pages/SeoPage";

// Component to conditionally render head based on route
function ConditionalHead() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");
  const isSeoPage = location.pathname.startsWith("/seo");

  // Use key prop to force remount when route changes
  // This ensures scripts/CSS are properly cleaned up and re-initialized
  if (isDashboard) {
    return <DashboardHead key="dashboard-head" />;
  }
  // Don't render MainHead for SEO pages - they have their own Helmet
  if (isSeoPage) {
    return <MainStyles key="main-styles-seo" />;
  }
  return <MainHead key="main-head" />;
}

// Component to conditionally render scripts based on route
function ConditionalScripts() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  // Use key prop to force remount when route changes
  // This ensures scripts are properly cleaned up and re-initialized
  if (!isDashboard) {
    return <MainScripts key={location.pathname} />;
  }
  return null;
}

const App = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <ConditionalHead />
          <ConditionalScripts />
          <Routes>
            <Route path="/" element={<Home5 />} />
            <Route path="/home2" element={<Home2 />} />
            <Route path="/home3" element={<Home3 />} />
            <Route path="/home4" element={<Home4 />} />
            {/* <Route path="/home5" element={<Home5 />} /> */}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/new_booking" element={<NewBooking />} />
            <Route
              path="/booking_confirmation"
              element={<BookingConfirmation />}
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/seo/:slug" element={<SeoPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Dashboard />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/profile"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Profile />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/bookings"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Bookings />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/bookings/details"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <BookingDetails />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;
